<div
  class="col-12 bg-white rounded mb-4 shadow-sm border-0">

  <!-- ===== HEADER DEL BUILDING ===== -->
  <div class="px-3 pt-3 pb-2 border-bottom">

    <!-- Fila superior: nombre + acciones -->
    <div class="d-flex align-items-start gap-2 mb-2">

      <div class="flex-grow-1 overflow-hidden">
        <h5 class="fw-bold mb-0 text-truncate">{{ streetBuilding!.name }}</h5>
        @if(authService.currentUser?.profile === 'sudo') {
          <div class="d-flex align-items-center mt-1">
            <span class="text-secondary small">#{{ streetBuilding!.streetBuildingId }}</span>
            <button
              (click)="utilService.copyToClipboard(streetBuilding!.streetBuildingId)"
              class="btn btn-sm p-0 ms-1 lh-1">
              <i class="material-icons text-secondary" style="font-size: 14px;">content_copy</i>
            </button>
          </div>
        }
      </div>

      <!-- Acciones del building -->
      <div class="d-flex align-items-center gap-1 flex-shrink-0">
        <button
          (click)="open(streetBuilding!)"
          class="btn btn-sm btn-light rounded-circle"
          placement="top"
          ngbTooltip="Editar">
          <i class="material-icons mt-1">edit</i>
        </button>
        <button
          (click)="delete(streetBuilding!)"
          class="btn btn-sm btn-danger rounded-circle">
          <i class="material-icons mt-1">delete</i>
        </button>
      </div>

    </div>

    <!-- Stats chips -->
    <div class="d-flex flex-wrap align-items-center gap-2 mb-2">

      <span class="badge rounded-pill bg-light text-dark border fw-normal">
        <i class="material-icons align-middle me-1" style="font-size: 13px;">home</i>
        {{ streetBuilding!.housesFlats.length }} casas
      </span>

      <span class="badge rounded-pill text-bg-success fw-normal">
        {{ streetBuilding!.activeHousesFlats }} activos
      </span>

      <span class="badge rounded-pill text-bg-danger fw-normal">
        {{ streetBuilding!.inactiveHouseFlat }} inactivos
      </span>

      @if (authService.currentUser?.profile === 'sudo') {
        <span
          class="badge rounded-pill bg-light text-dark border fw-normal"
          placement="top"
          ngbTooltip="Dispositivos activos">
          <i class="material-icons align-middle me-1" style="font-size: 13px;">phone_iphone</i>
          {{ streetBuilding!.totalDevicesActive }}
        </span>

        <span
          class="badge rounded-pill bg-light text-secondary border fw-normal"
          placement="top"
          ngbTooltip="Dispositivos inactivos">
          <i class="material-icons align-middle me-1" style="font-size: 13px;">phone_iphone</i>
          {{ streetBuilding!.totalDevicesInactive }} inact.
        </span>
      }

    </div>

    <!-- Controles collapse -->
    <div class="d-flex align-items-center gap-2">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        (click)="collapse.toggle()"
        [attr.aria-expanded]="!isCollapsed"
        aria-controls="collapseExample">
        <i class="material-icons align-middle me-1" style="font-size: 15px;">
          {{ isCollapsed ? 'expand_more' : 'expand_less' }}
        </i>
        {{ isCollapsed ? 'Mostrar' : 'Ocultar' }} casas
      </button>

      @if(!isCollapsed) {
        <button
          type="button"
          (click)="openHouseFlat()"
          class="btn btn-sm btn-success">
          <i class="material-icons align-middle me-1" style="font-size: 15px;">add</i>
          Agregar casa
        </button>
      }
    </div>

  </div>
  <!-- /HEADER -->

  <!-- ===== LISTA DE CASAS ===== -->
  <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">

    @for(houseFlat of streetBuilding!.housesFlats; track $index) {

      <div class="border-bottom px-3 py-2">
        <div class="d-flex align-items-center gap-2 flex-nowrap">

          <!-- Número de casa -->
          <span
            class="flex-shrink-0 fw-bold text-secondary border rounded-2 px-2 small"
            style="min-width: 3rem; text-align: center;">
            {{ houseFlat.number }}
          </span>

          <!-- Nombre del residente + tipo (bloque flexible, puede truncar) -->
          <div class="flex-grow-1 overflow-hidden d-flex flex-column justify-content-center">
            <span class="text-truncate fw-medium lh-sm">
              {{ houseFlat.fullName }}
              @if(houseFlat.creditBalance > 0) {
                <span class="badge text-bg-info ms-1">
                  ${{ houseFlat.creditBalance }}
                </span>
              }
            </span>
            <span class="text-muted small text-truncate lh-sm">
              {{ houseFlat.residentType?.description }}
            </span>
          </div>

          <!-- Notas (solo en pantallas grandes) -->
          <div
            class="d-none d-lg-block text-muted small text-truncate flex-shrink-0"
            style="max-width: 140px;"
            [innerHTML]="houseFlat.notes | newlineToBr">
          </div>

          <!-- Código -->
          <span class="badge bg-light text-dark border flex-shrink-0 d-none d-sm-inline-flex">
            {{ houseFlat.code }}
          </span>

          <!-- Status badge -->
          <span class="flex-shrink-0">
            @if(houseFlat.status) {
              <span class="badge rounded-pill text-bg-success">Activo</span>
            } @else {
              <span class="badge rounded-pill text-bg-danger">Inactivo</span>
            }
          </span>

          <!-- Contadores (ocultos en mobile) -->
          <div class="d-none d-md-flex align-items-center gap-2 flex-shrink-0 text-muted small">

            <span
              class="d-flex align-items-center gap-1"
              placement="top"
              ngbTooltip="Usuarios">
              <i class="material-icons text-success" style="font-size: 16px;">person_outline</i>
              {{ houseFlat.residents.length }}
            </span>

            <span
              class="d-flex align-items-center gap-1"
              placement="top"
              ngbTooltip="Invitaciones">
              <i class="material-icons" style="font-size: 16px;">mail_outline</i>
              {{ houseFlat.invitations.length }}
            </span>

            @if(authService.currentUser?.profile === 'sudo') {
              <span
                class="d-flex align-items-center gap-1"
                placement="top"
                ngbTooltip="Dispositivos">
                <i class="material-icons" style="font-size: 16px;">phone_iphone</i>
                {{ houseFlat.devices.length }}
              </span>
            }

          </div>

          <!-- Switch -->
          <div class="flex-shrink-0 ms-auto">
            <p-inputSwitch
              (onChange)="update(houseFlat)"
              [(ngModel)]="houseFlat.status">
            </p-inputSwitch>
          </div>

          <!-- Menú ⋮ — siempre visible -->
          <div
            ngbDropdown
            class="flex-shrink-0"
            placement="bottom-end">
            <button
              type="button"
              class="btn btn-sm btn-light rounded-circle"
              [id]="houseFlat.houseFlatId"
              ngbDropdownToggle>
              <span class="material-icons">
                <small>more_vert</small>
              </span>
            </button>
            <div ngbDropdownMenu>

              @if(authService.currentUser?.profile === 'sudo') {
                <button
                  ngbDropdownItem
                  class="d-flex align-items-center"
                  (click)="openDevices(houseFlat)">
                  <i class="material-icons text-secondary me-2">phone_iphone</i>
                  Dispositivos
                </button>

                <button
                  ngbDropdownItem
                  class="d-flex align-items-center"
                  (click)="openTags(houseFlat)">
                  <i class="material-icons text-secondary me-2">style</i>
                  Accesos
                </button>

                <button
                  ngbDropdownItem
                  class="d-flex align-items-center"
                  (click)="openNotification(houseFlat)">
                  <i class="material-icons text-secondary me-2">notifications</i>
                  Enviar notificación
                </button>
              }

              <button
                ngbDropdownItem
                class="d-flex align-items-center"
                (click)="openResidents(houseFlat)">
                <i class="material-icons text-secondary me-2">person_outline</i>
                Usuarios
              </button>

              <a
                ngbDropdownItem
                class="d-flex align-items-center"
                [routerLink]="[streetBuilding?.streetBuildingId, 'houses-flats', houseFlat.houseFlatId, 'passes']">
                <i class="material-icons text-secondary me-2">style</i>
                Pases
              </a>

              <a
                ngbDropdownItem
                class="d-flex align-items-center"
                [routerLink]="['/neighborhoods', streetBuilding!.neighborhoodId, 'streets-buildings', streetBuilding!.streetBuildingId, 'houses-flats', houseFlat.houseFlatId, 'payments']">
                <i class="material-icons text-secondary me-2">account_balance_wallet</i>
                Pagos
              </a>

              <a
                ngbDropdownItem
                class="d-flex align-items-center"
                [routerLink]="['/neighborhoods', streetBuilding!.neighborhoodId, 'streets-buildings', streetBuilding!.streetBuildingId, 'houses-flats', houseFlat.houseFlatId, 'notice-violations']">
                <i class="material-icons text-secondary me-2">gavel</i>
                Amonestaciones
              </a>

              <button
                ngbDropdownItem
                class="d-flex align-items-center"
                (click)="openHouseFlat(houseFlat)">
                <i class="material-icons text-secondary me-2">edit</i>
                Editar
              </button>

              <div class="dropdown-divider"></div>

              <button
                ngbDropdownItem
                class="d-flex align-items-center text-danger"
                (click)="deleteHouseFlat(houseFlat)">
                <i class="material-icons me-2">delete</i>
                Borrar
              </button>

            </div>
          </div>
          <!-- /Menú ⋮ -->

        </div>
      </div>

    }

  </div>
  <!-- /LISTA DE CASAS -->

</div>
